<div [hidden]="!loading">
    <div  class="thp-form-container" >
        <div class="thp-message">
            <h1 class="thp-header">{{'gather.loading-text' | translate}}</h1>
            <div class="spinner-container">
                <mat-spinner [diameter]="40"></mat-spinner>
            </div>
        </div>
    </div>
</div>
